export enum OptionsEnum {
  ALL = "All elements",
  MY = "My elements",
}
